export default __webpack_public_path__ + "static/media/complementary--accident-area--g2.6b892819.png";